import { getCreatorApiUrl } from '@client/components/api-urls';
import axios from 'axios';
import { httpClient } from './api';

export type EmailChallengeIntent = 'login' | 'signup' | 'update-signin-email';

export const sendEmailChallenge = async (
  email: string,
  intent?: EmailChallengeIntent,
) => {
  const response = await axios.post(getCreatorApiUrl('/send-confirmation'), {
    email,
    intent,
  });
  return response.data;
};

export const confirmEmailCode = async (
  email: string,
  code: string,
  intent?: EmailChallengeIntent,
): Promise<{ user?: unknown; token?: string }> => {
  const response = await axios.post(getCreatorApiUrl('/confirm-email'), {
    email,
    code,
    intent,
  });

  return response.data;
};

export const updateSignInEmail = async (
  email: string,
  token: string,
): Promise<void> => {
  await httpClient.post(getCreatorApiUrl('/portal-users/me/sign-in-email'), {
    email,
    token,
  });
};

export const loginWithUsernamePassword = async (
  username: string,
  password: string,
) => {
  const response = await axios.post(getCreatorApiUrl('/auth/login'), {
    username: username,
    password: password,
  });

  return response.data;
};
